// ===== PLACEHOLDER TAB - COMING SOON =====
const AlternativesTab = ({ building }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "500px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        background: "#fafbfc",
        flexDirection: "column",
        gap: "16px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "48px" }}>♻️</div>
      <h3 style={{ fontSize: "20px", fontWeight: 600, margin: 0, color: "#333" }}>
        Low Carbon Material Alternatives
      </h3>
      <p style={{ fontSize: "14px", color: "#666", margin: 0, maxWidth: "400px" }}>
        Discover sustainable material alternatives to reduce your building's carbon footprint
      </p>
      <p style={{ fontSize: "12px", color: "#999", marginTop: "8px" }}>
        Advanced AI-powered material recommendations and carbon reduction strategies will be available in this section.
      </p>

      {/* TODO: BACKEND INTEGRATION */}
      {/* 
        When backend is ready, replace this placeholder with:
        
        1. Fetch API: GET /api/v1/buildings/{buildingId}/material-alternatives
        
        Expected response:
        {
          alternatives: [
            {
              currentMaterial: string,
              alternatives: [
                {
                  name: string,
                  carbonReduction: number (%),
                  cost: number,
                  availability: string,
                  supplier: string,
                  certifications: [string]
                }
              ]
            }
          ]
        }
        
        2. Display alternatives in a tabular format
        3. Allow users to compare materials
        4. Show cost/benefit analysis
      */}
    </div>
  );
};

export default AlternativesTab;
